import { Component, OnInit } from '@angular/core';
import { ServicioGeneral } from 'src/app/_services/servicio-general.service';
import { Slider } from 'src/app/model/slider';


@Component({
  selector: 'app-slider-emvs',
  templateUrl: './slider-emvs.component.html',
  styleUrls: ['./slider-emvs.component.css']
})
export class SliderEmvsComponent implements OnInit {
  
  imageObject:Array<Slider> = [];
  constructor(private servicioGeneral: ServicioGeneral) {
    this.servicioGeneral.getSlider().subscribe({
      next: (value) => {
        this.imageObject=value;
      },
      error: (err) => {
        console.error(err);
      }
    })
   }
 
  ngOnInit(): void {
  }

}
